import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreModule } from '../core';
import { EkubRoutingModule } from '../ekub/ekub-routing.module';
import { EkubsComponent } from './ekubs.component';
import { EkubAddComponent } from '../ekub/ekub.add.component';
import { CategoriesComponent } from '../ekub/categories.component';
import { AwardsComponent } from './awards.component';
import { AwardAddComponent } from './award.add.component';
import { EkubDetailComponent } from '../ekub/ekub.detail.component';
import { AwardDetailComponent } from '../ekub/award.detail.component';
import { FusionChartsModule } from 'angular-fusioncharts';
import * as FusionCharts from 'fusioncharts';
import * as Charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxImageCompressService } from 'ngx-image-compress';

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

@NgModule({
  imports: [CommonModule, BrowserModule, FormsModule, ReactiveFormsModule, NgSelectModule, FusionChartsModule,
    CoreModule, EkubRoutingModule, HttpModule, NgxDropzoneModule],
  declarations: [EkubsComponent, EkubAddComponent, EkubDetailComponent, CategoriesComponent, AwardsComponent, AwardAddComponent, AwardDetailComponent],
  providers: [
    NgxImageCompressService]
})
export class EkubModule { }
